import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { catchError, throwError } from 'rxjs';
import { FlamingoAuthService } from './flamingo-auth.service';

export const flamingoHttpInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(FlamingoAuthService);
    const router = inject(Router);
    const jwtHelper = inject(JwtHelperService);
    const authHeader = authService.getToken();

    console.log('🔧 Interceptor Function - URL:', req.url);
    console.log('🔧 Interceptor Function - Token:', authHeader);
    console.log('🔧 Interceptor Function - Existing Content-Type:', req.headers.get('Content-Type'));

    // Check if token is expired before making the request
    if (authHeader) {
        try {
            const isTokenExpired = jwtHelper.isTokenExpired(authHeader);
            if (isTokenExpired) {
                console.log('🔧 Interceptor Function - Token expired, redirecting to login');
                authService.logout();
                router.navigate(['/auth']);
                return throwError(() => new Error('Token expired'));
            }
        } catch (error) {
            console.error('🔧 Interceptor Function - Error checking token expiration:', error);
            authService.logout();
            router.navigate(['/auth']);
            return throwError(() => new Error('Invalid token'));
        }
    }

    // Build headers preserving existing ones
    let headers = req.headers;

    // Ensure Content-Type is set for JSON requests (but not for FormData)
    if (!headers.has('Content-Type') && req.body && typeof req.body === 'object' && !(req.body instanceof FormData)) {
        headers = headers.set('Content-Type', 'application/json');
        console.log('🔧 Interceptor Function - Added Content-Type: application/json');
    }

    // Add Authorization header if token exists
    if (authHeader) {
        headers = headers.set('Authorization', 'Bearer ' + authHeader);
        console.log('🔧 Interceptor Function - Added Authorization header');
    } else {
        console.log('🔧 Interceptor Function - No token found');
    }

    // Clone request only if headers changed
    const modifiedReq = headers !== req.headers ? req.clone({ headers }) : req;

    return next(modifiedReq).pipe(
        catchError((error: HttpErrorResponse) => {
            // Handle 401 Unauthorized (token expired or invalid)
            if (error.status === 401) {
                console.log('🔧 Interceptor Function - Received 401, token expired or invalid, redirecting to login');
                authService.logout();
                router.navigate(['/auth']);
            }
            return throwError(() => error);
        })
    );
};
